export enum InfoBoxSeverity {
  SUCCESS = 'success',
  INFORMATIVE = 'informative',
  WARNING = 'warning',
  ERROR = 'error',
  UPDATE = 'update',
}

export enum Events {
  INFO_BOX_UPDATED = 'infoBoxUpdated',
  DISMISSED = 'infoBoxDismissed',
}
